import { Component, EventEmitter, Output } from '@angular/core';
import { ModalComponent } from '../../../shared/components/modal/modal.component';
import {
  FormGroup,
  FormControl,
  Validators,
  ReactiveFormsModule,
} from '@angular/forms';
import { CommonModule } from '@angular/common';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'aig-modal-insert-email',
  imports: [ModalComponent, CommonModule, ReactiveFormsModule],
  templateUrl: './modal-insert-email.component.html',
  styleUrl: './modal-insert-email.component.scss',
})
export class ModalInsertEmailComponent {
  @Output() hideModal: EventEmitter<boolean> = new EventEmitter<boolean>();
  clickHide(): void {
    this.hideModal.emit(true);
  }
  public mailForm: FormGroup = new FormGroup({});

  constructor(private AuthService: AuthService) {
    this.buildForm();
  }

  public onSubmitResetPassword() {
    if (this.mailForm.valid) {
      if (this.mailForm.value.mail.trim()) {
        this.AuthService.resetPassword(this.mailForm.value.mail).subscribe({
          next: (response) => {
            // Si la respuesta es exitosa, establecemos IsEmailSent a true
            this.hideModal.emit(true);
          },
          error: (err) => {
            // Si ocurre un error, podemos manejarlo aquí
            console.error('Error al enviar el email: ', err);
            this.hideModal.emit(true);
          },
          complete: () => {},
        });
      }
    }
  }

  //#region PRIVATE METHODS
  private buildForm(): void {
    this.mailForm = new FormGroup({
      mail: new FormControl('', Validators.required),
    });
  }

  //#endregion
}
